import { render, staticRenderFns } from "./FormPhoneInput.vue?vue&type=template&id=25d898f4&scoped=true"
import script from "./FormPhoneInput.vue?vue&type=script&lang=js"
export * from "./FormPhoneInput.vue?vue&type=script&lang=js"
import style0 from "./FormPhoneInput.vue?vue&type=style&index=0&id=25d898f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d898f4",
  null
  
)

export default component.exports